import { ITranslationRequest } from "../base/translation";

// Interface for store quantity in PUT requests
export interface IStoreQuantityRequest {
  store_id: number;
  price?: number;
  price_in_dollar?: number;
  purchase_price?: number;
  purchase_price_in_dollar?: number;
  general_discount?: boolean;
  special_discount?: boolean;
  value_general_discount?: number;
  value_special_discount?: number;
  status?: number;
  id_accounting?: string | null;
  barcodes?: string[];
  /** The stock level at which the purchase forecast starts asking for this
   *  product in this store, in *selling* units (kg / pieces), never grams.
   *  Omitting it leaves the stored value alone, `null` clears it — and a
   *  product with no reorder point is never ordered by the report at all. */
  reorder_point?: number | null;
  /** The scale of this same store. Omitting it leaves the attachment alone,
   *  `null` detaches, and a value detaches from any other scale in that store. */
  scale_id?: number | null;
  /** The slot to sit in, from `free-slots`. Sent on its own it moves the
   *  product inside the scale it is already on. */
  scale_hotkey?: number | null;
}

interface IAttributes {
  attributeId: number;
  values: string[];
}

export interface ICreateProduct {
  name: ITranslationRequest;
  note: ITranslationRequest;
  extraName: ITranslationRequest;
  description: ITranslationRequest;
  type: number;
  status: number;
  trademarkId: number;
  mainCategoryId: number;
  parentCategoryId: number;
  childCategoryId: number;
  storeId?: number;
  needRecipe: boolean;
  soldByUnit: boolean;
  /** Integer grams, 0..100000. Only sent while `soldByUnit` is true; the server
   * zeroes it otherwise and refuses a positive value. */
  scanQuantityTolerance?: number;
  requiresTripStartCheck?: boolean;
  attributes: IAttributes[];
  tagIds: number[];
  unitPartitionIds: number[];
  imageId?: Number;
  unitId: number;
  isNew: boolean;
  freeDelivery: boolean;
  generalDiscount: boolean;
  specialDiscount: boolean;
  valueGeneralDiscount?: number;
  valueSpecialDiscount?: number;
  price: number;
  priceInDollar: number;
  purchasePrice?: number;
  purchasePriceInDollar?: number;
  sliceId: number;
  storeQuantities?: IStoreQuantityRequest[];
}

// IUpdateProduct is different from ICreateProduct
// PUT requests don't have global price fields - use storeQuantities instead
export interface IUpdateProduct {
  name?: ITranslationRequest;
  note?: ITranslationRequest;
  extraName?: ITranslationRequest;
  description?: ITranslationRequest;
  type?: number;
  status?: number;
  trademarkId?: number;
  mainCategoryId?: number;
  parentCategoryId?: number;
  childCategoryId?: number;
  storeId?: number;
  needRecipe?: boolean;
  soldByUnit?: boolean;
  /** Same contract as on create. */
  scanQuantityTolerance?: number;
  requiresTripStartCheck?: boolean;
  attributes?: IAttributes[];
  tagIds?: number[];
  unitPartitionIds?: number[];
  imageId?: Number;
  unitId?: number;
  isNew?: boolean;
  freeDelivery?: boolean;
  sliceId?: number;
  // Price fields are ONLY in storeQuantities for PUT
  storeQuantities?: IStoreQuantityRequest[];
}

export interface IAddQuantity {
  storeQuantities: {
    store_id: number;
    added_quantity: number;
  }[];
}

export interface IMatchQuantity {
  storeQuantities: {
    store_id: number;
    entered_quantity: number;
    withdrawn_quantity: number;
  }[];
}

export interface IdAccounting {
  storeAccountings: {
    store_id: number;
    id_accounting: string;
  }[];
}


export interface IManageProductStore {
  operation: number;
  productId: number;
  stores: number[];
  price: number;

  available: boolean;
  discountPercentage: number;
  isDiscount: boolean;
  note: string;
}
export interface IImportExcelProductStore {
  storeId: number;
  available: boolean;
  isDiscount: boolean;
  fileId: number;
}

export interface IImportExcelProduct {
  id: number;
  name: string;
  trademark: number;
  status: boolean;
  price: number;
  priceInDollar: number;
  fileId: number;
}

export interface IExportProductExcel {
  id: boolean;
  name: boolean;
  extraName: boolean;
  type: boolean;
  status: boolean;
  needRecipe: boolean;
  isNew: boolean;
  soldByUnit: boolean;
  available: boolean;
  description: boolean;
  note: boolean;
  weighting: boolean;
  watch: boolean;
  trademark: boolean;
  parentCategory: boolean;
  mainCategory: boolean;
  unit: boolean;
  generalDiscount: boolean;
  specialDiscount: boolean;
  valueGeneralDiscount: boolean;
  valueSpecialDiscount: boolean;
  createdAt: boolean;
  price: boolean;
  unitPartition: boolean;
  priceInDollar: boolean;
  purchasePrice: boolean;
  purchasePriceInDollar: boolean;
}

export const colomnsExportProductExcel = [
  "id",
  "name",
  "extraName",
  "type",
  "status",
  "needRecipe",
  "isNew",
  "soldByUnit",
  "available",
  "description",
  "note",
  "weighting",
  "watch",
  "trademark",
  "parentCategory",
  "mainCategory",
  "unit",
  "generalDiscount",
  "specialDiscount",
  "valueGeneralDiscount",
  "valueSpecialDiscount",
  "createdAt",
  "price",
  "priceInDollar",
  "purchasePrice",
  "purchasePriceInDollar",
];
